'use strict';

require('sass/apply/application.scss');

var Reflux             = require('reflux'),
    _                  = require('underscore'),
    React              = require('react'),
    Router             = require('react-router'),
    PageMixin          = require('js/shared/utils/page-mixin.js'),
    ApplicationActions = require('js/shared/actions/application-actions.js'),
    ApplicationStore   = require('js/shared/stores/application-store.js');

var QuestionPage = require('js/screens/form/application-question-page.jsx');
var ReviewPage = require('js/screens/form/application-reviewpage.jsx'),
    InfoPage   = require('js/screens/form/application-infopage.jsx');

var STAGES = require('js/shared/utils/application-stages.js');
var QUESTIONS = require('js/screens/form/questions.jsx');

var STORES = [ApplicationStore];

var Application = React.createClass({
  mixins: [new PageMixin(STORES), Router.State].concat(_.map(STORES, function (store) {
    return Reflux.listenTo(store, '_updateState');
  })),

  contextTypes: {
    router: React.PropTypes.func
  },

  componentDidMount: function() {
    document.title = 'Apply to Hack The North | September 18–20 2015';
    ApplicationActions.setInitialValues({
      email: this.getQuery().email
    });
  },

  getInitialState: function() {
    return {
      form: QUESTIONS
    };
  },

  _handleNextQuestion: function() {
    if (this.state.application.page + 1 === this.state.form.length) {
      ApplicationActions.completeForm();
    }
    else {
      var page = this.state.application.page;

      var fieldName;
      if (page >= 0 && page < this.state.form.length){
        fieldName = this.state.form[page].fieldName;
      } else {
        fieldName = 'unknown-page-' + page;
      }
      ApplicationActions.nextQuestionPage({fieldName: fieldName});
    }
  },

  _handlePrevQuestion: function() {
    if(this.state.application.page > 0) {
      ApplicationActions.changeQuestionPage(this.state.application.page - 1);
    }
  },

  _handleHomepageClick: function() {
    ApplicationActions.homepageClick();
  },

  _changeAppStage: function(toStage) {
    var $this = this;
    return function() {
      if (toStage === STAGES.SUBMITTED)
        ApplicationActions.submitApplication({
          application: $this.state.application,
          review: false
        });
      else
        ApplicationActions.changeStage(toStage);
    };
  },

  _getCurrentQuestion: function() {
    return this.state.form[this.state.application.page];
  },

  _getQuestionValue: function(fieldName) {
    return this.state.application.values[fieldName];
  },

  _getQuestionHasError: function(fieldName) {
    return this.state.application.getError(fieldName);
  },

  _handleApplicationSubmit: function() {
    ApplicationActions.submitApplication({
      application: this.state.application,
      review: true
    });
  },

  render: function() {
    var $this = this;
    var body = null;

    var reviewButton = {
      text: "Review",
      handler: this._changeAppStage(STAGES.REVIEW)
    };

    var submitButton = {
      text: this.state.application.submitting ? "Submitting..." : "Submit",
      handler: this._handleApplicationSubmit.bind(this),
      disabled: this.state.application.submitting
    };
    var homepageButton = {
      text: "Complete My Application",
      handler: this._handleHomepageClick
    };

    if (this.state.application.stage === STAGES.APPLICATION) {
      var question = this._getCurrentQuestion();
      var questionValue = this._getQuestionValue(question.fieldName);
      var questionHasError = this._getQuestionHasError(question.fieldName);
      question.value = questionValue;

      body = (
          <QuestionPage
            question={question}
            hasError={questionHasError}
            stepCount={this.state.form.length}
            currentStep={this.state.application.page}
            nextQuestionHandler={this._handleNextQuestion}
            prevQuestionHandler={this._handlePrevQuestion}
            stepsCompleted={this.state.application.maxPageCompleted} />
      );
    }
    else if (this.state.application.stage === STAGES.COMPLETED) {
      var pageTitle = "Sweet! You've finished your application.";
      body  = (
        <InfoPage
          key="completed"
          leftButton={submitButton}
          rightButton={reviewButton}>
          <div className="InfoPage">
            <div className="InfoPage-title">
              {pageTitle}
            </div>
            <div className="InfoPage-subtitle">
              Submit, or review your application before submitting.
            </div>
          </div>
        </InfoPage>
      );
    }
    else if (this.state.application.stage === STAGES.REVIEW) {
      body = <ReviewPage
                key="review"
                values={this.state.application.values}
                questions={this.state.form}
                application={this.state.application}
                errors={this.state.application.errors} />;
    }
    else if (this.state.application.stage === STAGES.SUBMITTED) {

      body = (
        <InfoPage
          key="submitted"
          leftButton={homepageButton}>
          <div className="InfoPage">
            <div className="InfoPage-title">
              We’ve sent you a confirmation email and we’re excited!
            </div>
            <div className="InfoPage-subtitle">
              If you DO NOT receive an email from us, your application was <b>not</b> successfully submitted.
              You can now use your email and password to <u>complete your application</u>.
            </div>
          </div>
        </InfoPage>
      );
    }

      // return (
      //   <div className="application">
      //     <h2 className="application-header">
      //       Apply To Be A Hacker
      //     </h2>
      //     {body}
      //   </div>
      // );

    var closedMessage = "Unfortunately, we've closed applications for the year. We hope to see you again next fall!";

    return (
      <div className="application">
        <center>
          <h1 className="QuestionInput-title">Applications are now closed :-(</h1>
          <h1>{closedMessage}</h1>
        </center>
      </div>
      )
  }
});

module.exports = Application;



/** WEBPACK FOOTER **
 ** ./js/screens/form/application.jsx
 **/